// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1esnc","obliqueLineWrap":"membershipbadge_obliqueLineWrap__Kbsuv","obliqueLine":"membershipbadge_obliqueLine__11Aci"};